import React, { useState } from 'react';
import { Button, Form, FormInstance, Space } from 'antd';
import { Drawer, PrimaryButton } from '@common/components';
import { useMutation } from '@common/hooks';
import { createWorksProfileAction } from './works-profile-helper';
import { CandidateForm } from '.';
import { CreateWorksProfile } from '@clinician-profile/graphql';
import { Store } from 'antd/lib/form/interface';

const Footer = ({
  onClose,
  form,
  loading,
}: {
  onClose: () => void;
  form: FormInstance;
  loading: boolean;
}) => (
  <Space>
    <Button size="large" key="back" onClick={onClose}>
      Cancel
    </Button>
    <PrimaryButton size="large" onClick={form.submit} loading={loading}>
      Create Profile
    </PrimaryButton>
  </Space>
);

export function CreateCandidateDrawer({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [form] = Form.useForm();

  const [formSubmitting, setFormSubmitting] = useState(false);

  const onCloseDrawer = () => {
    form.resetFields();
    onClose();
  };

  const [createWorksProfile] = useMutation(
    CreateWorksProfile,
    createWorksProfileAction(form, onCloseDrawer)
  );

  const onFinish = (values: Store) => {
    setFormSubmitting(true);

    const worksProfileInput = {
      input: {
        profileType: values.profileType,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        dateOfBirth: values.dateOfBirth,
        profileSummary: values.profileSummary,
        ssn: values.ssn?.length ? values.ssn : undefined,
        phone: values.phone,
        roleId: values.roleId,
        primarySpecialtyId: values.specialtyId,
        secondarySpecialtyIds: values.secondarySpecialtyIds,
      },
    };

    createWorksProfile({ variables: worksProfileInput }).then(() =>
      setFormSubmitting(false)
    );
  };

  return (
    <Drawer
      title="New Candidate"
      open={open}
      onClose={onCloseDrawer}
      footer={
        <Footer onClose={onCloseDrawer} form={form} loading={formSubmitting} />
      }
    >
      <CandidateForm
        form={form}
        onFinish={onFinish}
        formSubmitting={formSubmitting}
      />
    </Drawer>
  );
}
